module.exports = __webpack_public_path__ + "static/img/banner.0258b50.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner.png
// module id = zrrE
// module chunks = 0